import quetionAdd from './quetionAdd';
import { openTextUserError, scrollDown } from './LitlModules';
import changeLevel from './changeLevel';
import { pcsicle, mobailCle, CountElementIsDOM } from './whereStCicle';
// let clx = 0;
const whereSteyFunc = (e, p) => {
	// try {
	e.preventDefault();
	const sel = localStorage.getItem('WhereStayUser');
	console.log(sel);
	if (!sel) {
		//сделать уведомления с надписью "я не знаю где ты остановился"
		return openTextUserError('notInfoWheyStay', 'я не знаю где ты остановился');
	}

	// если вопрос уже существует просто долистаем до нее
	const selen = document.querySelector('.' + sel);

	if (selen) {
		return selen.scrollIntoView({ block: 'start', behavior: 'smooth' });
	}

	// if (sel) {

	const selectorQuestionLevel = sel.replace(/(question)(\d)+/, ''); // узнаю к какой группе вопрос принадлежит
	const numberQuestion =
			sel.replace(/(tick|cross|heart|flower)(question)/, '') - 1,
		body = document.body,
		html = document.documentElement,
		width = Math.max(
			body.scrollWidth,
			body.offsetWidth,
			html.clientWidth,
			html.scrollWidth,
			html.offsetWidth
		); // номер вопроса

	let selectorQuestionopen;

	console.log(selectorQuestionLevel);
	// существуют ли вопросы
	const selectorQues = document.querySelector(`.wrapper`);

	// есть? да значит смотрим что вопросы с какой группы сущесвтуют : вопроов нету
	selectorQues
		? (selectorQuestionopen = selectorQues.classList[1].replace(
				/(question)(\d)+/,
				''
		  ))
		: (selectorQuestionopen = null);

	// с какого вопроса начать
	let index = document.querySelectorAll('.tinRightIn').length || 0;

	// if(selectorQuestionopen === selectorQuestionLevel){
	//   console.log('нажимать на изменения урвоня нет смысла!');
	// }
	// console.log(`${selectorQuestionopen} !== ${selectorQuestionLevel} || !${selectorQuestionopen}`);

	if (selectorQuestionopen !== selectorQuestionLevel || !selectorQuestionopen) {
		// console.log('переклюать нужно для мобилок iphone!');
		//    window.quetiAddn = true;
		changeLevel(document.querySelector('.' + selectorQuestionLevel));

		if (global.mobaleMOde && width <= 775) {
			if (numberQuestion === 0) return; // если нужно запустить первый ворос то он и так сгенерируется

			let timeset = setTimeout(() => {
				index = CountElementIsDOM();
				// index = document.querySelectorAll('.tinRightIn').length||0;

				mobailCle(index, numberQuestion);
				console.log('Цыкл для mobail!');

				clearTimeout(timeset);
			}, 800);
		} else {
			let timeset = setTimeout(() => {
				index = CountElementIsDOM();
				pcsicle(numberQuestion, index);

				clearTimeout(timeset);
			}, 800);
			console.log('Цыкл для PC!');
		}
	} else {
		console.log('переключать не нужно ');
		//  index = document.querySelectorAll('.tinRightIn').length-1;
		index = CountElementIsDOM();
		global.mobaleMOde && width <= 775
			? mobailCle(numberQuestion, index, p)
			: pcsicle(numberQuestion, index, p);
	}

	//  } catch (error) {console.error(error); }
};

export default whereSteyFunc;
